import { getLocalStorage } from "../../shared/utils/localStorage";
import { setTrendingFeed } from "../../pages/FeedPage/state/actions";
import constants from "../../shared/constants";
import storageConstants from "../../shared/constants/storage";

const { TEN_MINUTES, TRENDING_API_ROUTE } = constants;
const { LAST_TRENDING_UPCOMING_FETCH } = storageConstants;

export const createTrendingItemsFetcher = (activeHubIndex, appProvider, cancelTokenSource, dispatch) => {
  const checkAndFetchTrendingItems = () => {
    const lastFetchTime = getLocalStorage(LAST_TRENDING_UPCOMING_FETCH);
    const currentTime = Date.now();

    if (activeHubIndex === 0 && (!lastFetchTime || currentTime - lastFetchTime >= TEN_MINUTES)) {
      dispatch(setTrendingFeed(appProvider, TRENDING_API_ROUTE, cancelTokenSource));
    }
  };

  const startWorker = () => {
    const worker = new Worker(new URL("../../webWorker", import.meta.url), { type: "module" });

    worker.onmessage = () => {
      try {
        checkAndFetchTrendingItems();
      } catch (error) {
        console.error("Error handling worker message:", error);
      }
    };

    worker.postMessage({ action: "start", interval: TEN_MINUTES });

    return worker;
  };

  return { startWorker };
};
